<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-16 14:59:02
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-07-10 19:04:45
 * @Description: 附件列表封装
-->
<template>
  <div>
    <div class="uploadFile">
      <UploadFile
        ref="uploadFile"
        :limit="20"
        v-if="showUpload"
        buttonText="点击上传附件"
        :beforeUpload="beforeUpload"
        tip="单个文件大小不能超过100mb,且上传文件个数不超过20个"
        @afterSuccess="onSuccess"
        :showFileList="false"
      />
    </div>
    <el-table border :data="list" style="width: 100%" max-height="400">
      <el-table-column
        header-align="center"
        align="center"
        prop="fileName"
        width="200px"
        label="文件名"
      >
        <template slot-scope="scope">
          <a :href="scope.row.fileUrl" target="_blank">{{
            scope.row.fileName
          }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="fileSize"
        header-align="center"
        align="center"
        label="文件大小"
      >
        <template slot-scope="scope">
          {{ formatFileSize(scope.row.fileSize || 0) }}
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="createUserName"
        label="上传人"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="createTime"
        width="140px"
        label="上传时间"
      >
      </el-table-column>
      <el-table-column header-align="center" v-if="showUpload" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row, scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="btns" v-if="isAdd && showBtns">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" class="mgl" type="primary" @click="comfirm">提交</el-button>
    </div>
    <div class="btns" v-else-if="showBtns">
      <el-button size="small" @click="cancel">关闭</el-button>
    </div>
  </div>
</template>

<script>
import UploadFile from '@/components/upload/file.vue'
export default {
  props: {
    showUpload: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    showBtns: {
      type: Boolean,
      default: true
    },
    ossIds: {
      type: Array,
      default: function () {
        return []
      }
    },
    enclosureInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    UploadFile
  },
  data () {
    return {
      list: []
    }
  },
  created () {
    // 如果是新增就不处理
    if (!this.isAdd) {
      this.getAttachments()
    } else {
      this.list = [...this.ossIds]
    }
  },
  methods: {
    // 取消
    cancel () {
      this.$emit('cancel')
    },
    // 确定
    comfirm () {
      if (this.isAdd) {
        this.$emit('comfirm', [...this.list])
      } else {
        this.cancel()
      }
    },
    // 获取附件列表
    getAttachments () {
      let obj = {}
      let http = this.$http.get
      if (this.enclosureInfo.searchMethod === 'GET') {
        obj = {
          params: { ...this.enclosureInfo.extra }
        }
      } else {
        http = this.$http.post
        obj = { ...this.enclosureInfo.extra }
      }
      http(this.enclosureInfo.searchUrl, obj).then(({ data: res }) => {
        if (res.code === 0 && res.data) {
          const arr = res.data
          arr.forEach((item) => {
            if (item.url) {
              item.fileUrl = item.url
            }
          })
          this.list = arr
          this.$emit('afterSearch', res.data.length)
          this.$emit('sendResult', res.data)
        } else {
          this.list = []
        }
      })
    },
    // 上传前校验
    beforeUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传的附件不得大于100MB')
        return false
      }
    },
    // 上传成功回调
    onSuccess (res) {
      const obj = {
        aliOssId: res.aliOssId,
        fileName: res.fileName,
        fileSize: res.fileSize,
        fileType: res.fileType,
        fileUrl: res.url,
        createUserName: res.createUserName,
        createTime: res.createTime
      }
      // 新增走本地 编辑走接口
      if (this.isAdd) {
        this.list.push(obj)
        return
      }
      // 如果是详情
      const obj2 = {
        ...this.enclosureInfo.extra,
        aliOssId: res.aliOssId,
        ossId: res.aliOssId // 冗余字段 后端字段不一致的问题
      }
      this.$http.post(this.enclosureInfo.addUrl, obj2).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message.success('上传成功')
          this.getAttachments()
        }
      })
    },
    // 删除
    handleDelete (row, index) {
      if (this.isAdd) {
        this.list.splice(index, 1)
        return
      }
      this.$confirm('此操作将删除该附件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const obj = {
          ...this.enclosureInfo.extra,
          [this.enclosureInfo.urlKey || this.enclosureInfo.listAliOssKey]:
            row[this.enclosureInfo.listAliOssKey]
        }
        this.$http
          .post(this.enclosureInfo.deleteUrl, obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.getAttachments()
              this.$message.success(res.message || '删除成功')
            }
          })
      })
    },
    formatFileSize (fileSize) {
      if (fileSize < 1024) {
        return fileSize + 'B'
      } else if (fileSize < 1024 * 1024) {
        let temp = fileSize / 1024
        temp = temp.toFixed(2)
        return temp + 'KB'
      } else if (fileSize < 1024 * 1024 * 1024) {
        let temp = fileSize / (1024 * 1024)
        temp = temp.toFixed(2)
        return temp + 'MB'
      } else {
        let temp = fileSize / (1024 * 1024 * 1024)
        temp = temp.toFixed(2)
        return temp + 'GB'
      }
    },
    getList () {
      return this.list
    }
  }
}
</script>

<style lang="scss" scoped>
.uploadFile {
  padding: 0 0 12px 0;
  ::v-deep .el-upload-list {
    display: none;
  }
}
.btns {
  padding: 30px 0 0;
  text-align: center;
  .mgl {
    margin-left: 32px;
  }
}
</style>
